// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"23dcd062","455":"64aa8326","977":"94a845bd"}[chunkId] + ".chunk.js";
};